export const FilterValidationSchema = {
    email: [
        { rule: "required", message: "Email address required" },
        { rule: "email", message: "Email is invalid" }
    ],
    // address: [
    //     { rule: "required", message: "Address required" },
    // ],
}